import { PersonStanding } from 'lucide-react';
import { teamMembers } from '../data/team';
import { useSlideIn } from '../hooks/useSlideIn';

function MemberCard({ member }) {
  return (
    <div data-testid={"team-member-" + member.id} className="group text-center">
      <div className="relative mb-5 overflow-hidden aspect-[3/4] bg-zinc-100 border border-zinc-200">
        {member.image ? (
          <div
            className="absolute inset-0 group-hover:scale-105 transition-transform duration-500"
            style={{
              backgroundImage: "url(" + member.image + ")",
              backgroundSize: "cover",
              backgroundPosition: member.imagePosition || "center top",
              backgroundRepeat: "no-repeat"
            }}
          />
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-neutral-900 via-zinc-800 to-neutral-900 flex flex-col items-center justify-center overflow-hidden">
            {/* Dezente Linien als Hintergrundgrafik */}
            <div
              className="absolute inset-0 opacity-[0.07]"
              style={{
                backgroundImage:
                  "repeating-linear-gradient(45deg, #E31E24 0 1px, transparent 1px 14px)"
              }}
              aria-hidden="true"
            />
            {/* Akzent-Streifen oben */}
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-[#E31E24]" aria-hidden="true" />
            {/* Strichmännchen */}
            <PersonStanding
              className="w-36 h-36 text-zinc-200 group-hover:text-white group-hover:scale-110 transition-all duration-500"
              strokeWidth={1.25}
            />
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 pt-12">
          <p className="text-white font-bold text-lg">{member.name}</p>
          <p className="text-[#E31E24] font-semibold text-sm">{member.role}</p>
        </div>
      </div>
      <p className="text-neutral-600 text-sm leading-relaxed px-2">{member.description}</p>
    </div>
  );
}

export function Team() {
  var anim = useSlideIn();
  var cards = [];
  for (var i = 0; i < teamMembers.length; i++) {
    cards.push(<MemberCard key={teamMembers[i].id} member={teamMembers[i]} />);
  }

  return (
    <section id="team" data-testid="team-section" className="py-20 md:py-32 bg-zinc-50">
      <div ref={anim.ref} className={"max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 slide-in-left" + (anim.isVisible ? " visible" : "")}>
        <div className="text-center mb-16">
          <span className="inline-block text-[#E31E24] font-semibold text-sm uppercase tracking-widest mb-4">
            Unser Team
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-neutral-900 mb-6">
            Die Menschen hinter Fesch
          </h2>
          <p className="text-neutral-600 text-base lg:text-lg max-w-2xl mx-auto">
            {"Ein junges, engagiertes Team mit Leidenschaft f\u00fcr Elektrotechnik \u2013 kompetent, zuverl\u00e4ssig und immer f\u00fcr Sie da."}
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-8">
          {cards}
        </div>
      </div>
    </section>
  );
}

export default Team;
